import { TaxonLite } from "../../Services/models/taxon";

export class TaxonUrlParams {
  public taxons: TaxonLite[] = [];
  public productCode: string;
}
